import { render, staticRenderFns } from "./pagePrincipale.vue?vue&type=template&id=72c22ef8"
import script from "./pagePrincipale.vue?vue&type=script&lang=js"
export * from "./pagePrincipale.vue?vue&type=script&lang=js"
import style0 from "./pagePrincipale.vue?vue&type=style&index=0&id=72c22ef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports